<template>
  <div class="row">
    <div class="col-md-12 col-sm-12 col-xs-12">
      <div class="x_panel">
        <div class="x_title">
          <h2>
            Documents
            <button
              class="btn btn-default btn--upload-document"
              @click="addDocumentDialog = true"
            >
              <i class="fa fa-download"></i> Upload new document
            </button>
          </h2>
          <div class="clearfix"></div>
        </div>
        <div class="x_content">
          <table class="table table-hover">
            <thead>
              <tr>
                <th>File ID#</th>
                <th>Name</th>
                <th>Date added</th>
                <th>Added by</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody v-if="item.documents.length == 0 ">
              <tr>
                <td colspan="5" class="text-center">
                  <h3>No documents found!</h3>
                </td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr v-for="(file, index) in item.documents" :key="index">
                <th scope="row" v-if="file.id">
                  <span
                    v-if="documentsUpdates.length > 0 && isNew(file.id)"
                    class="tab-updates tab-updates--documents mini"
                  ></span>
                  {{ index + 1 }}
                </th>
                <td v-if="file.file.name">{{ file.file.name }}</td>
                <td v-if="file.created">{{ file.created | moment('DD/MM/YYYY') }}</td>
                <td
                  v-if="file.uploadedBy"
                >{{ file.uploadedBy.firstName }} {{ file.uploadedBy.lastName }}</td>
                <td v-if="file.file.url">
                  <a
                    :href="file.file.url.replace('https://s3.amazonaws.com/zeedog-oms/', 'https://debjazey4nj7y.cloudfront.net/')"
                    :download="file.file.url.replace('https://s3.amazonaws.com/zeedog-oms/', 'https://debjazey4nj7y.cloudfront.net/')"
                    target="_blank"
                  >Download</a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <el-dialog title="Add a new document" :visible.sync="addDocumentDialog">
      <el-upload
        drag
        :action="documentUploadUrl"
        :file-list="file"
        :on-success="onSuccess"
        :on-error="onError"
        :headers="getHeaders"
        multiple
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">
          Drop file here or
          <em>click to upload</em>
        </div>
        <div class="el-upload__tip" slot="tip">
          <i class="el-icon-information"></i> Add here files related to this PO
        </div>
      </el-upload>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addDocumentDialog = false">Cancel</el-button>
        <!-- <el-button type="success" @click="addDocumentDialog = false">Confirm</el-button> -->
      </span>
    </el-dialog>
  </div>
</template>

<script>
import apiUrl from "@/services/api_url";
import getFileUploadHeaders from "@/services/http-file-headers";

export default {
  props: {
    item: {
      type: Object,
      default() {
        return {};
      }
    },
    updates: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      addDocumentDialog: false,
      file: [],
      documentsUpdates: []
    };
  },
  computed: {
    documentUploadUrl() {
      return `${apiUrl}pos/${this.item.id}/documents/`;
    },
    getHeaders() {
      return getFileUploadHeaders();
    }
  },
  created() {
    for (let i = 0; i < this.updates.length; i += 1) {
      if (Object.prototype.hasOwnProperty.call(this.updates[i], "documents")) {
        this.documentsUpdates = this.updates[i].documents;
      }
    }
  },
  methods: {
    isNew(id) {
      if (this.documentsUpdates.indexOf(id) > -1) {
        return true;
      }
      return false;
    },
    onSuccess() {
      this.$store.dispatch("setPOItem", this.item.id);
      this.$message.success("Document saved!");
      this.addDocumentDialog = false;
    },
    onError() {
      this.$message.error("Something went wrong, please try again");
    },
    clearFiles(formName) {
      this.$refs[formName].resetFields();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/purchase-orders/purchase-order/partials/PoDocuments.vue